import { Outlet } from "react-router-dom";
import { useTheme } from "../styles/theme";
import Toast from "../components/Toast";
import Header from "../components/Header";
import Nav from "../components/Nav";

export default function AppLayout() {
  const S = useTheme();
  return (
    <div style={S.root}>
      <div style={S.bgGrid} />
      <Toast />
      <Header />
      <Nav />
      <main style={S.main}>
        <Outlet />
      </main>
      <footer style={S.footer}>ProfitLens © 2025</footer>
    </div>
  );
}
